import { META_FALLBACK_IMAGE } from './../constants'

export const centreAddress = centre => ({
  '@type': 'PostalAddress',
  addressLocality: centre.suburb,
  addressRegion: centre.state,
  postalCode: centre.postcode,
  streetAddress: centre.physicalAddress,
})

const tradingHoursToStructuredData = hours =>
  hours &&
  hours.map(tradingHoursOfADay => ({
    '@type': 'OpeningHoursSpecification',
    opens: tradingHoursOfADay.openingTime,
    closes: tradingHoursOfADay.closingTime,
    validFrom: tradingHoursOfADay.date,
    validThrough: tradingHoursOfADay.date,
  }))

export const getCentreStructuredData = ({
  url,
  centre,
  name,
  description,
  tradingHours,
}) => {
  // TODO: In event a url is not available don't return incomplete structured data
  if (!url) {
    return null
  }

  return {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name,
    url,
    description,
    mainEntity: {
      openingHoursSpecification: tradingHoursToStructuredData(tradingHours),
      '@type': 'ShoppingCenter',
      name,
      image: META_FALLBACK_IMAGE,
      description,
      url,
      address: centreAddress(centre),
      sameAs: [centre.facebook, centre.instagram].filter(elem => elem),
    },
  }
}
